// extracted by mini-css-extract-plugin
export var infoItem = "_pm-2";
export var title = "_pm-0";
export var value = "_pm-1";